import { Anchor } from "@govlaunch/web";
import Link from "next/link";
import React from "react";
import { FormattedMessage } from "react-intl";
import { IGovernmentProject, IGroup, IGroupProject, IVendorProject, ICity } from "~/types/types";
import nextLinkHref from "~/src/utils/nextLinkHref";

interface IProjectBackLinkProps {
  project: GroupProject | GovernmentProject | VendorProject;
}

export function ProjectBackLink({ project }: IProjectBackLinkProps) {
  if (project.__typename === "GovernmentProject") {
    return (
      <Link
        href={`/government?governmentSlug=${project.government.slug}&content=projects`}
        as={`/governments/${project.government.slug}/projects`}
        passHref={true}
      >
        <Anchor>
          <FormattedMessage
            defaultMessage="← View all projects by {name}" id="kyYwqz"
            values={{ name: project.government.city.name }}
          />
        </Anchor>
      </Link>
    );
  }

  if (project.__typename === "GroupProject" && project.group.viewerIsMember) {
    const linkHref = nextLinkHref(`/groups/${project.group.slug}`, { content: "projects" });

    return (
      <Link href={linkHref} passHref={true}>
        <Anchor>
          <FormattedMessage defaultMessage="← View all projects by {name}" id="kyYwqz" values={{ name: project.group.name }} />
        </Anchor>
      </Link>
    );
  }

  return (
    <Link href="/projects" passHref={true}>
      <Anchor>
        <FormattedMessage defaultMessage="← View other projects" id="omw1HT" />
      </Anchor>
    </Link>
  );
}

type GroupProject = Pick<IGroupProject, "__typename"> & {
  group: Pick<IGroup, "slug" | "viewerIsMember" | "name">;
};

type GovernmentProject = Pick<IGovernmentProject, "__typename"> & {
  government: Pick<IGovernmentProject, "slug"> & {
    city: Pick<ICity, "name">;
  };
};

type VendorProject = Pick<IVendorProject, "__typename">;
